export const normalizeBoard = (board) => {
    if (board.Status === 'FAILED') {
        return {
            status: board.Status,
            message: board.Message,
        };
    }
    const updatedTime = board.DataUpdated ? new Date(board.DataUpdated).getTime() : undefined;
    const calculateAge = board.IntegrationType === 'Datafile';
    return {
        recordCount: board.RecordCount,
        status: board.Status,
        usageCount: board.boardUsage,
        updatedTime,
        calculateAge,
    };
};
